// DoctorNotes.js
import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import "./DoctorNotes.css";
import DeleteIcon from "../../Setting/SettingsAssets/Delete.svg";
import { useApp } from "../../../AppProvider";
import { useAuth } from "../../../AuthProvider";
import api from "./../../../axiosInstance"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AppointmentSelectSlotPage from '../../../Components/Appointment/AppointmentSelectSlotPage';
import MedicalCertificateModal from './Modal/MedicalCertificate/MedicalCertificateModal';
import { getPatientAge } from '../../../Utils';


const DoctorNotes = () => {
  const pdfRef = useRef();
  const { setPastSidebarToggle, mediTableContent, setMediTableContent, doctorAdvice, setDoctorAdvice, diagnosisCards, setDiagnosisCards, selectedPatientObj, selectedClinic, selectedAppointment, mediTableContentLabTest, setMediTableContentLabTest, prescriptionOptions } = useApp();
  const { user } = useAuth()
  const [menuPortalTarget, setMenuPortalTarget] = useState(null);
  const [activeTab, setActiveTab] = useState('Patient-info');
  const [symptomCards, setSymptomCards] = useState([]);

  const [rememberCards, setRememberCards] = useState([]);
  const [medicationAdvice, setMedicationAdvice] = useState([]);
  const [activeSection, setActiveSection] = useState(null);
  const [symptomInput, setSymptomInput] = useState('');
  const [diagnosisInput, setDiagnosisInput] = useState('');
  const [rememberInput, setRememberInput] = useState('');
  const [appointmentInput, setAppointmentInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isFollowUpOpen, setIsFollowUpOpen] = useState(false);
  const [showPrescriptionConfirm, setShowPrescriptionConfirm] = useState(false);
  const [prescriptionLang, setPrescriptionLang] = useState('en');
  const [showMedicalCertModal, setShowMedicalCertModal] = useState(false);
  const [certSuccessMsg, setCertSuccessMsg] = useState('');

  const [symptomOptions] = useState([
    "Fever (Pyrexia)", "Chills / Rigors", "Fatigue (Asthenia)", "Generalized Weakness", "Malaise", "Night Sweats", "Unintentional Weight Loss", "Weight Gain", "Loss of Appetite (Anorexia)", "Failure to Thrive", "Cough", "Dry Cough", "Productive Cough", "Hemoptysis (Coughing Blood)",
    "Shortness of Breath (Dyspnea)", "Wheezing", "Chest Tightness", "Orthopnea", "Paroxysmal Nocturnal Dyspnea", "Stridor",
    "Chest Pain (Angina)", "Palpitations", "Syncope (Fainting)", "Pre-syncope", "Peripheral Edema", "Cyanosis", "Claudication",
    "Cold Extremities", "Headache (Cephalalgia)", "Migraine", "Dizziness (Vertigo)", "Seizures (Convulsions)",
    "Loss of Consciousness", "Memory Loss (Amnesia)", "Tremors", "Paresthesia (Tingling)", "Numbness (Hypoesthesia)",
    "Weakness / Paralysis", "Nausea", "Vomiting (Emesis)", "Abdominal Pain", "Epigastric Pain", "Heartburn (Pyrosis)",
    "Dyspepsia", "Bloating / Flatulence", "Diarrhea", "Constipation", "Melena (Black Stool)", "Hematochezia (Blood in Stool)",
    "Jaundice (Icterus)", "Burning Micturition (Dysuria)", "Frequent Urination (Polyuria)", "Urgency", "Nocturia",
    "Hematuria (Blood in Urine)", "Urinary Retention", "Incontinence", "Myalgia (Muscle Pain)", "Arthralgia (Joint Pain)",
    "Back Pain (Lumbago)", "Neck Pain (Cervicalgia)", "Joint Swelling", "Joint Stiffness", "Reduced Range of Motion",
    "Skin Rash", "Pruritus (Itching)", "Urticaria (Hives)", "Dry Skin (Xerosis)", "Hyperpigmentation", "Hair Loss (Alopecia)",
    "Nail Changes", "Sore Throat (Pharyngitis)", "Hoarseness", "Ear Pain (Otalgia)", "Hearing Loss", "Tinnitus",
    "Blurred Vision", "Double Vision (Diplopia)", "Eye Pain", "Red Eye (Conjunctivitis)", "Excessive Thirst (Polydipsia)",
    "Excessive Hunger (Polyphagia)", "Heat Intolerance", "Cold Intolerance", "Excessive Sweating (Hyperhidrosis)", "Anxiety",
    "Depressed Mood", "Irritability", "Sleep Disturbance (Insomnia)", "Daytime Somnolence", "Panic Attacks",
    "Poor Concentration"
  ]);

  const [diagnosisOptions] = useState([
    "Viral Fever", "Influenza (Flu)", "COVID-19", "Dengue Fever", "Chikungunya", "Malaria", "Typhoid Fever",
    "Tuberculosis", "Upper Respiratory Tract Infection", "Lower Respiratory Tract Infection", "Acute Bronchitis", "Pneumonia",
    "Allergic Rhinitis", "Sinusitis", "Pharyngitis", "Otitis Media", "Conjunctivitis", "Urinary Tract Infection",
    "Acute Gastroenteritis", "Helicobacter pylori Infection", "Hypertension", "Coronary Artery Disease", "Ischemic Heart Disease",
    "Congestive Heart Failure", "Atrial Fibrillation", "Arrhythmia", "Peripheral Artery Disease", "Cardiomyopathy",
    "Valvular Heart Disease", "Deep Vein Thrombosis", "Type 1 Diabetes Mellitus", "Type 2 Diabetes Mellitus", "Prediabetes",
    "Dyslipidemia", "Metabolic Syndrome", "Hypothyroidism", "Hyperthyroidism", "Thyroiditis", "Obesity",
    "Polycystic Ovary Syndrome (PCOS)", "Gastritis", "Gastroesophageal Reflux Disease (GERD)", "Peptic Ulcer Disease",
    "Irritable Bowel Syndrome", "Inflammatory Bowel Disease", "Constipation", "Hemorrhoids", "Fatty Liver Disease",
    "Hepatitis B", "Hepatitis C", "Cirrhosis of Liver", "Migraine", "Tension Headache", "Epilepsy", "Stroke",
    "Transient Ischemic Attack", "Vertigo", "Parkinson’s Disease", "Multiple Sclerosis", "Peripheral Neuropathy",
    "Alzheimer’s Disease", "Bronchial Asthma", "Chronic Obstructive Pulmonary Disease (COPD)", "Pulmonary Tuberculosis",
    "Interstitial Lung Disease", "Sleep Apnea Syndrome", "Chronic Kidney Disease", "Acute Kidney Injury", "Renal Calculi",
    "Benign Prostatic Hyperplasia", "Prostatitis", "Urinary Incontinence", "Iron Deficiency Anemia",
    "Vitamin B12 Deficiency Anemia", "Thalassemia", "Leukemia", "Thrombocytopenia", "Osteoarthritis", "Rheumatoid Arthritis",
    "Low Back Pain", "Sciatica", "Cervical Spondylosis", "Osteoporosis", "Fibromyalgia", "Gout", "Anxiety Disorder",
    "Depressive Disorder", "Bipolar Disorder", "Schizophrenia", "Obsessive Compulsive Disorder", "Atopic Dermatitis", "Psoriasis",
    "Fungal Skin Infection", "Acne Vulgaris", "Vitiligo", "Vitamin D Deficiency", "Vitamin B12 Deficiency", "Iron Deficiency",
    "Protein Energy Malnutrition", "Acute Diarrhea", "Chronic Diarrhea", "Food Poisoning", "Indigestion", "Acid Peptic Disorder",
    "Traveller’s Diarrhea", "Intestinal Worm Infestation", "Lactose Intolerance", "Gastric Upset", "Common Cold",
    "Seasonal Flu", "Viral Pharyngitis", "Tonsillitis", "Laryngitis", "Allergic Cough", "Post-Viral Cough", "Nasal Polyps",
    "Deviated Nasal Septum", "Contact Dermatitis", "Heat Rash (Miliaria)", "Scabies", "Ringworm (Tinea)",
    "Boils / Furunculosis", "Skin Allergy", "Sunburn", "Insect Bite Reaction", "Dehydration", "Heat Exhaustion",
    "Motion Sickness", "Jet Lag", "Generalized Body Pain", "Overwork Fatigue", "Low Immunity", "Colic", "Teething Problems",
    "Failure to Gain Weight", "Pediatric Viral Fever", "Worm Infestation in Children", "Premenstrual Syndrome (PMS)",
    "Irregular Menstruation", "Dysmenorrhea", "Menorrhagia", "Leucorrhea", "Urinary Tract Infection in Pregnancy",
    "Dry Eye Syndrome", "Refractive Error", "Stye (Hordeolum)", "Dental Caries", "Gingivitis", "Tooth Sensitivity",
    "Work-Related Stress", "Exam Anxiety", "Burnout Syndrome", "Adjustment Disorder"
  ]);

  const [rememberOptions] = useState([
    "Review blood test reports", "Review urine examination results", "Review imaging reports", "Check ECG findings", "Review previous prescriptions", "Compare current and past reports", "Confirm pending investigations", "Verify outside lab reports", "Reassess pain severity", "Check fever pattern", "Review cough progression", "Assess breathlessness", "Evaluate appetite and weight", "Review bowel habits",
    "Review sleep quality", "Assess fatigue level", "Confirm medication compliance", "Check for adverse drug reactions",
    "Review response to antibiotics", "Assess need for dose adjustment", "Evaluate treatment tolerance", "Check inhaler technique",
    "Review insulin usage", "Verify medication timing", "Review blood sugar records", "Review blood pressure readings",
    "Assess diabetic complications", "Screen for hypertension complications", "Check lipid profile status", "Monitor renal function",
    "Monitor thyroid profile", "Review diet adherence", "Assess physical activity level", "Check smoking/alcohol status",
    "Review stress levels", "Assess sleep routine", "Encourage weight management", "Ask about warning symptoms",
    "Check for hospital admissions", "Assess fall risk", "Review chest pain episodes", "Evaluate syncopal events",
    "Assess neurological changes", "Check vaccination status", "Review cancer screening history", "Assess need for boosters",
    "Advise preventive checkups", "Review specialist opinion", "Confirm referral compliance", "Discuss referral findings",
    "Plan further referrals if needed", "Update medical history", "Update problem list", "Revise treatment plan",
    "Plan next follow-up date", "Update digital records", "Document clinical progress"
  ]);

  const [adviceOptions] = useState([
    "Take adequate rest and avoid physical exertion", "Ensure proper sleep of at least 7–8 hours daily", "Avoid overworking and manage stress levels", "Resume normal activity gradually after recovery",
    "Drink plenty of fluids and stay well hydrated", "Consume warm fluids like soup and herbal tea", "Follow a balanced and nutritious diet", "Avoid outside food,junk food,and oily items", "Eat small,frequent meals",
    "Include fruits and vegetables in daily diet", "Avoid alcohol and smoking", "Monitor body temperature regularly",
    "Do not self-medicate with antibiotics", "Complete the prescribed course of medicines", "Maintain proper personal hygiene",
    "Use mask in crowded places if advised", "Do steam inhalation twice daily", "Gargle with warm salt water",
    "Avoid cold drinks and cold exposure", "Avoid dust,smoke,and pollutants", "Avoid spicy and acidic food",
    "Take meals at regular intervals", "Do not skip meals", "Avoid lying down immediately after eating",
    "Maintain proper hand hygiene before meals", "Monitor blood pressure regularly", "Monitor blood sugar levels as advised",
    "Take medicines regularly without missing doses", "Maintain a healthy weight", "Follow lifestyle modification as advised",
    "Avoid heavy lifting and sudden movements", "Maintain correct posture while sitting and working", "Do light stretching exercises regularly", "Apply warm compress if advised", "Keep the affected area clean and dry", "Avoid scratching the affected area",
    "Use prescribed topical medications only", "Avoid sharing personal items", "Practice relaxation techniques such as meditation", "Engage in regular physical activity", "Limit screen time before sleep", "Seek emotional support from family and friends",
    "Avoid driving or operating machinery if dizzy", "Follow infection prevention measures", "Get routine health checkups", "Keep vaccinations up to date", "Report immediately if symptoms worsen", "Return for follow-up as advised", "Seek emergency care if severe symptoms occur",
    "Do not ignore persistent symptoms", "Take medicines only as prescribed", "Do not stop medicines without consultation", "Store medicines in a cool and dry place", "Maintain a health record for future reference"
  ]);

  const handleDeleteMedicine = (serialNo) => {
    const updatedMediTableContent = mediTableContent
      .filter((item) => item.serialNo !== serialNo)
      .map((item, index) => ({ ...item, serialNo: (index + 1).toString() }));
    setMediTableContent(updatedMediTableContent);
  };

  const handleDeleteTest = (serialNo) => {
    const updatedTestMediTableContent = mediTableContentLabTest
      .filter((item) => item.serialNo !== serialNo)
      .map((item, index) => ({ ...item, serialNo: (index + 1).toString() }));
    setMediTableContentLabTest(updatedTestMediTableContent);
  }

  const handleClickPatientInfo = () => {
    setPastSidebarToggle(false);
    setActiveTab('Patient-info');
    setSymptomCards([]);
    setDiagnosisCards([]);
    setRememberCards([]);
    setDoctorAdvice([]);
    setMedicationAdvice([]);
  };

  const handleClickPastRecords = () => {
    setPastSidebarToggle(true);
    setActiveTab('Past-records');
    setSymptomCards([]);
    setDiagnosisCards([]);
    setRememberCards([]);
    setDoctorAdvice([]);
    setMedicationAdvice([]);

  };

  const handleSymptomChange = (selectedOptions) => {
    const newCards = selectedOptions.map(option => (option.label));
    setSymptomCards(prevCards => [...prevCards, ...newCards]);
  };

  const handleDiagnosisChange = (selectedOptions) => {
    // const newCards = selectedOptions.map(option => ({
    //   value: option.value,
    //   label: option.label
    // }));
    const newCards = selectedOptions.map(option => (option.label));
    setDiagnosisCards(prevCards => [...prevCards, ...newCards]);
  };

  const handleRememberChange = (selectedOptions) => {
    // const newCards = selectedOptions.map(option => ({
    //   value: option.value,
    //   label: option.label
    // }));
    const newCards = selectedOptions.map(option => (option.label));
    setRememberCards(prevCards => [...prevCards, ...newCards]);
  };

  // ✅ Safe version
  const handleAdviceChange = (selectedOptions) => {
    if (!selectedOptions?.length) return;
    const newCards = selectedOptions.map(option => option.label);
    setDoctorAdvice(prevCards => [...prevCards, ...newCards]);
  };

  const handleSymptomInputKeyDown = (event) => {
    if (event.key === 'Enter' && symptomInput) {
      // const newCard = { value: symptomInput, label: symptomInput };
      event.preventDefault();      // stops selection
      event.stopPropagation();     // stops react-select internal handler
      setSymptomCards(prevCards => [...prevCards, symptomInput]);
      setSymptomInput('');
    }
  };

  const handleDiagnosisInputKeyDown = (event) => {
    if (event.key === 'Enter' && diagnosisInput) {
      event.preventDefault();      // stops selection
      event.stopPropagation();     // stops react-select internal handler
      // const newCard = { value: diagnosisInput, label: diagnosisInput };
      setDiagnosisCards(prevCards => [...prevCards, diagnosisInput]);
      setDiagnosisInput('');
    }
  };

  const handleRememberInputKeyDown = (event) => {
    if (event.key === 'Enter' && rememberInput) {
      event.preventDefault();      // stops selection
      event.stopPropagation();     // stops react-select internal handler
      // const newCard = { value: rememberInput, label: rememberInput };
      setRememberCards(prevCards => [...prevCards, rememberInput]);
      setRememberInput('');
    }
  };

  const handleAppointmentInputKeyDown = (event) => {
    if (event.key === 'Enter' && appointmentInput) {
      event.preventDefault();      // stops selection
      event.stopPropagation();     // stops react-select internal handler
      // const newCard = { value: appointmentInput, label: appointmentInput };
      setDoctorAdvice(prevCards => [...prevCards, appointmentInput]);
      setAppointmentInput('');
    }
  };

  const removeSymptomCard = (index) => {
    const newCards = [...symptomCards];
    newCards.splice(index, 1);
    setSymptomCards(newCards);
  };

  const removeDiagnosisCard = (index) => {
    const newCards = [...diagnosisCards];
    newCards.splice(index, 1);
    setDiagnosisCards(newCards);
  };

  const removeRememberCard = (index) => {
    const newCards = [...rememberCards];
    newCards.splice(index, 1);
    setRememberCards(newCards);
  };

  // const removeAdviceCard1 = (index) => {
  //   const newCards = [...advice];
  //   newCards.splice(index, 1);
  //   setDoctorAdvice(newCards);
  // };
  const removeAdviceCard = (index) => {
    const newAdvice = [...doctorAdvice];
    // const newMedicationAdvice = [...medicationAdvice];

    newAdvice.splice(index, 1);
    // newMedicationAdvice.splice(index, 1);

    setDoctorAdvice(newAdvice);
    // setMedicationAdvice(newMedicationAdvice);
  };

  const removeMedicationAdviceCard = (index) => {
    const newMedicationAdvice = [...medicationAdvice];
    newMedicationAdvice.splice(index, 1);
    setMedicationAdvice(newMedicationAdvice);
  };

  const renderSymptomCards = () => (
    symptomCards.map((symptom, index) => (
      <div key={index} className="symptom-card">
        {symptom}
        <span className="card-remove" onClick={() => removeSymptomCard(index)}>x</span>
      </div>
    ))
  );

  const renderDiagnosisCards = () => (
    diagnosisCards.map((diagnosis, index) => (
      <div key={index} className="diagnosis-card">
        {diagnosis}
        <span className="card-remove" onClick={() => removeDiagnosisCard(index)}>x</span>
      </div>
    ))
  );

  const renderRememberCards = () => (
    rememberCards.map((remember, index) => (
      <div key={index} className="remember-card">
        {remember}
        <span className="card-remove" onClick={() => removeRememberCard(index)}>x</span>
      </div>
    ))
  );

  const renderAdvice = () => (
    doctorAdvice.flatMap((itemAdvice, index) =>
      itemAdvice
        .split(/[\n,]/)           // split by newline OR comma
        .map(part => part.trim())
        .filter(part => part !== "")
        .map((part, partIndex) => (
          <div key={`${index}-${partIndex}`} className="appointment-card">
            {part}
            <span className="card-remove" onClick={() => removeAdviceCard(index)}>x</span>
          </div>
        ))
    )
  );

  const handleInputChange = (serialNo, columnKey, value) => {
    const updatedContent = mediTableContent.map((item) => {
      if (item.serialNo === serialNo) {
        return { ...item, [columnKey]: value };
      }
      return item;
    });
    setMediTableContent(updatedContent);
  };

  const createPdf = async (language = 'en', sendPdf = true) => {
    setIsLoading(true);

    const today = new Date();

    const body = {
      medications: mediTableContent,
      name: `${selectedPatientObj.name?.firstName || ''} ${selectedPatientObj.name?.lastName || ''}`,
      gender: selectedPatientObj.gender,
      age: getPatientAge(selectedPatientObj),
      bloodGroup: selectedPatientObj.bloodGroup,
      allergies: selectedPatientObj.allergies,
      symptoms: symptomCards.length ? symptomCards.join(', ') : undefined,
      diagnosis: diagnosisCards.length ? diagnosisCards.join(', ') : undefined,
      tests: mediTableContentLabTest?.length ? mediTableContentLabTest : undefined,
      advice: doctorAdvice?.length ? doctorAdvice.join(', ') : undefined,
      medicalCondition: selectedPatientObj.chronicConditions,
      doctorName: `${user.name?.firstName || ''} ${user.name?.lastName || ''}`,
      qualification: user.specilizations?.[0],
      registrationNumber: user.registrationNumber,
      phoneNumber: selectedClinic?.contact?.phoneNumber?.phoneNumber,
      clinicAdd: selectedClinic ? `${selectedClinic.name?.fullName}, ${selectedClinic.contact?.address?.addressLine1}` : undefined,
      patientId: selectedPatientObj._id,
      clinicId: selectedClinic?._id,
      appointmentId: selectedAppointment,
      dateOfPublish: today,
      typeOfRecord: "PrescriptionRecord",
      doctorId: user._id,
      language,
    };

    // ✅ Add optional fields only if they exist
    if (selectedPatientObj.weight) body.weight = selectedPatientObj.weight;
    if (selectedPatientObj.temperature) body.temperature = selectedPatientObj.temperature;
    if (rememberCards.length) body.doctorsNote = rememberCards.join(', ');

    // ✅ Remove all undefined fields automatically
    Object.keys(body).forEach(
      (key) => body[key] === undefined && delete body[key]
    );
    try {
      const response = await api.post(`/mhr/issuePrescription`, body, {
        responseType: 'blob',
        params: { sendPdf: sendPdf ? 'true' : 'false' }
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank');
      setMediTableContent([]);
      setMediTableContentLabTest([]);
      setDoctorAdvice([]);
      setDiagnosisCards([]);
      setSymptomCards([]);
      setRememberCards([]);
    } catch (error) {
      alert(`Error Generating Prescription: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="doctor-notes" ref={pdfRef}>
      <div className="container_toggle-main">
        <div className="toggle-box">
          <div
            onClick={handleClickPatientInfo}
            className={`Patient-info ${activeTab === 'Patient-info' ? 'active' : ''}`}
          >
            Patient info
          </div>
          <div
            onClick={handleClickPastRecords}
            className={`Past-records ${activeTab === 'Past-records' ? 'active' : ''}`}
          >
            Past records
          </div>
        </div>
      </div>
      <div className="input-main-container">
        <div>
          <label>Temperature: (°F)</label>
          <input type="text" className="input-main-container-text" />
        </div>
        <div>
          <label>Blood Pressure: (120/80 mmHg)</label>
          <input type="text" className="input-main-container-text" />
        </div>
        <div>
          <label>Weight: (Kg)</label>
          <input type="text" className="input-main-container-text" />
        </div>
      </div>
      <div className="doctor-notes-column-1">
        <div className="cards-section">
          <div
            className={`doctor-cards doctor-card-text ${activeSection === 'symptoms' ? 'active' : ''}`}
            onClick={() => setActiveSection('symptoms')}
          >
            <Select
              isMulti
              placeholder="Symptoms"
              value={[]}
              onChange={handleSymptomChange}
              inputValue={symptomInput}
              onInputChange={(input, { action }) => {
                if (action === 'input-change') setSymptomInput(input);
              }}
              onKeyDown={handleSymptomInputKeyDown}
              options={symptomOptions.map(symptom => ({
                label: symptom,
                value: symptom,
              }))}
              classNamePrefix="react-select"
              // className="react-select-container"
              menuPortalTarget={menuPortalTarget}
              styles={{
                menu: (base) => ({ ...base, height: 150 }),
                menuList: (base) => ({ ...base, maxHeight: 150 }),
              }}
            />
            <div className="cards-container">
              {renderSymptomCards()}
            </div>
          </div>
        </div>
        <div className="cards-section">
          <div
            className={`doctor-cards doctor-card-text ${activeSection === 'diagnosis' ? 'active' : ''}`}
            onClick={() => setActiveSection('diagnosis')}
          >
            <Select
              isMulti
              placeholder="Diagnosis"
              value={[]}
              onChange={handleDiagnosisChange}
              inputValue={diagnosisInput}
              onInputChange={(input, { action }) => {
                if (action === 'input-change') setDiagnosisInput(input);
              }}
              onKeyDown={handleDiagnosisInputKeyDown}
              options={diagnosisOptions.map(symptom => ({
                label: symptom,
                value: symptom,
              }))}
              classNamePrefix="react-select"
              // className="react-select-container"
              menuPortalTarget={menuPortalTarget}
              styles={{
                menu: (base) => ({ ...base, height: 150 }),
                menuList: (base) => ({ ...base, maxHeight: 150 }),
              }}
            />
            <div className="cards-container">
              {renderDiagnosisCards()}
            </div>
          </div>
        </div>
      </div>
      <div className="doctor-notes-column-2">
        <div className="cards-section">
          <div
            className={`doctor-cards doctor-card-text ${activeSection === 'appointment' ? 'active' : ''}`}
            onClick={() => setActiveSection('appointment')}
          >
            <Select
              isMulti
              placeholder="Advice"
              value={[]}
              onChange={handleAdviceChange}
              inputValue={appointmentInput}
              onInputChange={(input, { action }) => {
                if (action === 'input-change') setAppointmentInput(input);
              }}
              onKeyDown={handleAppointmentInputKeyDown}
              options={adviceOptions.map(symptom => ({
                label: symptom,
                value: symptom,
              }))}
              classNamePrefix="react-select"
              // className="react-select-container"
              menuPortalTarget={menuPortalTarget}
              styles={{
                menu: (base) => ({ ...base, height: 150 }),
                menuList: (base) => ({ ...base, maxHeight: 150 }),
              }}
            />
            <div className="cards-container">
              {renderAdvice()}
            </div>
          </div>
        </div>
        <div className="cards-section">
          <div
            className={`doctor-cards doctor-card-text ${activeSection === 'remember' ? 'active' : ''}`}
            onClick={() => setActiveSection('remember')}
          >
            <Select
              isMulti
              placeholder="Things to remember"
              value={[]}
              onChange={handleRememberChange}
              inputValue={rememberInput}
              onInputChange={(input, { action }) => {
                if (action === 'input-change') setRememberInput(input);
              }}
              onKeyDown={handleRememberInputKeyDown}
              options={rememberOptions.map(symptom => ({
                label: symptom,
                value: symptom,
              }))}
              classNamePrefix="react-select"
              // className="react-select-container"
              menuPortalTarget={menuPortalTarget}
              styles={{
                menu: (base) => ({ ...base, height: 150 }),
                menuList: (base) => ({ ...base, maxHeight: 150 }),
              }}
            />
            <div className="cards-container">
              {renderRememberCards()}
            </div>
          </div>
        </div>
      </div>
      <h2 className="doctor-notes-heading-medicine">Medicines</h2>
      <table className="doctor-notes-medi-table">
        <thead>
          <tr className="doctor-notes-medi-table-header">
            <th className="doctor-notes-medi-header-text drserialNo">S.No.</th>
            <th className="doctor-notes-medi-header-text">Brand Name</th>
            <th className="doctor-notes-medi-header-text">Drug Name</th>
            <th className="doctor-notes-medi-header-text">Quantity</th>
            <th className="doctor-notes-medi-header-text">Duration (days)</th>
            <th className="doctor-notes-medi-header-text">Dosage</th>
            <th className="doctor-notes-medi-header-text">When to Take</th>
            <th className="doctor-notes-medi-header-text">Remarks</th>
            <th className="doctor-notes-medi-header-text">Delete</th>
          </tr>
        </thead>
        <tbody>
          {mediTableContent.length > 0 ? (
            mediTableContent.map((group) => (
              <tr className="add__medicine-tableheader-col" key={group.serialNo}>
                <td className="doctor-notes-table-el">{group.serialNo}</td>
                <td className="doctor-notes-table-el-brand">{group.brand}</td>
                <td className="doctor-notes-table-el-durgs">{group.drugsName}</td>
                {/* Quantity */}
                <td className="doctor-notes-table-el">
                  <select
                    className="doctor-notes-table-input"
                    value={group.quantity || ""}
                    onChange={(e) => handleInputChange(group.serialNo, "quantity", e.target.value)} >
                    <option value="">Select quantity</option>
                    {(prescriptionOptions?.quantity || []).map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </td>
                {/* Duration */}
                <td className="doctor-notes-table-el">
                  <select
                    className="doctor-notes-table-input"
                    value={group.duration || ""}
                    onChange={(e) => handleInputChange(group.serialNo, "duration", e.target.value)} >
                    <option value="">Select duration</option>
                    {(prescriptionOptions?.duration || []).map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </td>
                {/* Dosage */}
                <td className="doctor-notes-table-el">
                  <select
                    className="doctor-notes-table-input"
                    value={group.dosage || ""}
                    onChange={(e) => handleInputChange(group.serialNo, "dosage", e.target.value)} >
                    <option value="">Select dosage</option>
                    {(prescriptionOptions?.dosage || []).map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </td>
                {/* When To Take */}
                <td className="doctor-notes-table-el">
                  <select
                    className="doctor-notes-table-input"
                    value={group.whenToTake || ""}
                    onChange={(e) => handleInputChange(group.serialNo, "whenToTake", e.target.value)}>
                    <option value="">Select time</option>
                    {(prescriptionOptions?.whenToTake || []).map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </td>
                {/* Remarks */}
                <td className="doctor-notes-table-el">
                  <input
                    className="doctor-notes-table-input"
                    type="text"
                    placeholder="Enter remarks"
                    value={group.remarks}
                    onChange={(e) => handleInputChange(group.serialNo, "remarks", e.target.value)} />
                </td>
                {/* Delete */}
                <td className="doctor-notes-table-el">
                  <img
                    className="medicine-delete_icon_doctor"
                    src={DeleteIcon}
                    alt="deleteicon"
                    onClick={() => handleDeleteMedicine(group.serialNo)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr className="add__medicine-no_medicine_selected">
              <td colSpan="9" className="add__medicine-no_medicine_selected-cell">
                No Medicine Selected
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <h2 className="doctor-notes-heading-test">Tests</h2>
      <table className="doctor-notes-test-table">
        <thead>
          <tr className="doctor-notes-test-thead-lab">
            <th className="doctor-notes-test-header-text drserialNo">S.No.</th>
            <th className="doctor-notes-test-header-text testnameWidth">Test Name</th>
            <th className="doctor-notes-test-header-text testnameWidth">Lab Name</th>
            <th className="doctor-notes-test-header-text delete-tests-th">Delete</th>
          </tr>
        </thead>
        <tbody>
          {mediTableContentLabTest.length > 0 ? (
            mediTableContentLabTest.map((test) => (
              <tr className="doctor-notes-test-table-body" key={test.serialNo}>
                <td className="doctor-notes-test-table-el drserialNo">{test.serialNo}</td>
                <td className="doctor-notes-test-table-el">{test.test}</td>
                <td className="doctor-notes-test-table-el">{test.department || <span>Lab name not Avilable</span>}</td>
                <td className="doctor-notes-test-table-el-delete">
                  <img
                    className="doctor-notes-test-delete-icon"
                    src={DeleteIcon}
                    alt="deleteicon"
                    onClick={() => handleDeleteTest(test.serialNo)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="test-no-tests-selected">
                No Tests Selected
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="div-btn-down">
        <button className="down-btn followup-btn" onClick={() => setIsFollowUpOpen(true)}>
          📅 Book Follow-up Appointment
        </button>
        <button className="down-btn down-btn--cert" onClick={() => setShowMedicalCertModal(true)}>
          Medical Certificate
        </button>
        <button className="down-btn" onClick={() => setShowPrescriptionConfirm(true)}>Issue Prescription</button>
      </div>

      {showPrescriptionConfirm && (
        <div className="popup-overlay">
          <div className="rx-confirm-popup">
            <h3 className="rx-confirm-title">Issue Prescription?</h3>
            <p className="rx-confirm-message">
              A prescription PDF will be sent to{' '}
              <strong>{selectedPatientObj?.name?.firstName} {selectedPatientObj?.name?.lastName}</strong>'s
              WhatsApp (<strong>{selectedPatientObj?.contact?.phoneNumber?.phoneNumber || 'N/A'}</strong>).
            </p>
            <div className="rx-confirm-lang-row">
              <label className="rx-confirm-lang-label">Prescription language</label>
              <select
                className="rx-confirm-lang-select"
                value={prescriptionLang}
                onChange={(e) => setPrescriptionLang(e.target.value)}
              >
                <option value="en">English</option>
                <option value="hi">Hindi</option>
                <option value="mr">Marathi</option>
                <option value="gu">Gujarati</option>
              </select>
            </div>
            <div className="rx-confirm-actions">
              <button
                className="rx-confirm-btn-cancel"
                onClick={() => setShowPrescriptionConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="rx-confirm-btn-no-wa"
                onClick={() => { setShowPrescriptionConfirm(false); createPdf(prescriptionLang, false); }}
              >
                Issue Only
              </button>
              <button
                className="rx-confirm-btn-issue"
                onClick={() => { setShowPrescriptionConfirm(false); createPdf(prescriptionLang); }}
              >
                Issue + Send WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}

      {isLoading && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>PDF is generating, please wait...</p>
          </div>
        </div>
      )}

      {isFollowUpOpen && (
        <AppointmentSelectSlotPage
          patient={selectedPatientObj}
          onClose={() => setIsFollowUpOpen(false)}
          setIsAppointmentSelectDatePopupOpen={setIsFollowUpOpen}
        />
      )}

      {showMedicalCertModal && (
        <MedicalCertificateModal
          onClose={(success) => {
            setShowMedicalCertModal(false);
            if (success) {
              setCertSuccessMsg('Medical certificate issued successfully.');
              setTimeout(() => setCertSuccessMsg(''), 4000);
            }
          }}
        />
      )}

      {certSuccessMsg && (
        <div className="cert-success-toast">{certSuccessMsg}</div>
      )}
    </div>
    // </div>
  );
};

export default DoctorNotes;
